import { formatCurrencyBRL } from "../../../utils/utils";
import {
  DashboardRow,
  KpiCard,
  KpiLabel,
  KpiValue,
  PaymentsRow,
  PaymentTag,
  Dot,
} from "./styles";

const paymentMethodsConfig = [
  { key: 'dinheiro', title: 'Dinheiro', color: '#5D9B76' },
  { key: 'pix', title: 'PIX', color: '#5290A8' },
  { key: 'debito', title: 'Debito', color: '#8B72BE' },
  { key: 'credito', title: 'Credito', color: '#007bff' },
  { key: 'cartao', title: 'Cartao', color: '#6c757d' },
  { key: 'prazo', title: 'A Prazo', color: '#D4764E' },
  { key: 'transferencia', title: 'Transferencia', color: '#6610f2' },
  { key: 'alelo', title: 'Alelo', color: '#e6a817' },
  { key: 'sodexo', title: 'Sodexo', color: '#dc3545' },
  { key: 'ticket', title: 'Ticket', color: '#20c997' },
  { key: 'vr', title: 'VR', color: '#e83e8c' },
  { key: 'vale', title: 'Vale', color: '#343a40' },
  { key: 'valeGas', title: 'Vale Gas', color: '#007bff' },
  { key: 'hospedagem', title: 'Hospedagem', color: '#8B72BE' },
];

const Totalizador = ({
  quantidade,
  totalizadorBruto,
  totalizadorLiquido,
  totalizadorTaxas,
  totalizadorTaxaAdm,
  totalPagamentos,
}) => {
  const totalTaxas = totalizadorTaxas + totalizadorTaxaAdm;
  const activePayments = paymentMethodsConfig.filter(
    (m) => totalPagamentos[m.key] > 0,
  );

  return (
    <>
      <DashboardRow>
        <KpiCard>
          <KpiLabel>Pedidos</KpiLabel>
          <KpiValue>{quantidade}</KpiValue>
        </KpiCard>
        <KpiCard>
          <KpiLabel>Subtotal</KpiLabel>
          <KpiValue $color="#5D9B76">{formatCurrencyBRL(totalizadorLiquido)}</KpiValue>
        </KpiCard>
        <KpiCard>
          <KpiLabel>Taxas + Adm</KpiLabel>
          <KpiValue $color="#D4764E">{formatCurrencyBRL(totalTaxas)}</KpiValue>
        </KpiCard>
        <KpiCard>
          <KpiLabel>Total</KpiLabel>
          <KpiValue>{formatCurrencyBRL(totalizadorBruto)}</KpiValue>
        </KpiCard>
      </DashboardRow>

      {activePayments.length > 0 && (
        <PaymentsRow>
          {activePayments.map((method) => (
            <PaymentTag key={method.key}>
              <Dot $color={method.color} />
              <span>{method.title}</span>
              <span>{formatCurrencyBRL(totalPagamentos[method.key])}</span>
            </PaymentTag>
          ))}
        </PaymentsRow>
      )}
    </>
  );
};

export default Totalizador;
